import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectFavouritesPopupVisible } from '../../modules/ui';
import { setFavouritesPopupVisibility } from '../../modules/ui/actions';

function useFavouritesPopup() {
  const dispatch = useDispatch();

  const showFavouritesPopup = useCallback(
    () => dispatch(setFavouritesPopupVisibility(true)),
    [dispatch]
  );
  const hideFavouritesPopup = useCallback(
    () => dispatch(setFavouritesPopupVisibility(false)),
    [dispatch]
  );

  const favouritesPopupVisible = useSelector(selectFavouritesPopupVisible);

  return {
    showFavouritesPopup,
    hideFavouritesPopup,
    favouritesPopupVisible,
  };
}

export { useFavouritesPopup };
